import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export const useAuctionData = (
  options: { wines?: string; store?: string; market?: string } = {}
) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/auction/clients/me/vae/data/',
    {
      params: {
        query: {
          market: options.market || undefined,
          store: options.store || undefined
        }
      }
    }
  );

  return {
    isLoading,
    auctionData: data || {
      kpis: {},
      avg_prices: [],
      volumes_and_values: [],
      filters: { client_wines: [], stores: [], markets: [] },
      feed: []
    },
    refetch
  };
};
